// types
import log from "loglevel";
import type { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

// page component
import { SearchPage } from "@/components/pages/search/SearchPage";

export default SearchPage;

export const getStaticProps: GetStaticProps = async context => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(context.locale as string, [
          "common",
          "homepage",
          "more-drawer",
          "searchpage",
          "recipe"
        ]))
      }
    };
  } catch (e) {
    log.error("%0", e);

    return {
      props: {
        notFound: true
      }
    };
  }
};
